import React, { useState } from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  FormControl,
  FormLabel,
  Input,
  Button,
  useToast,
  Link,
} from '@chakra-ui/react';
import { Link as RouterLink, useNavigate, Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { authApi } from '../services/api';

const Signup = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const ref = params.get('ref') || undefined;  // código de indicação
  const { login, isAuthenticated } = useAuth();
  const [form, setForm] = useState({ company: '', name: '', email: '', password: '' });
  const [loading, setLoading] = useState(false);

  if (isAuthenticated) return <Navigate to="/inicio" replace />;

  const submit = async () => {
    if (!form.company.trim() || !form.name.trim() || !form.email.trim() || form.password.length < 8) {
      toast({ title: 'Preencha tudo (senha com 8+ caracteres)', status: 'warning', duration: 2500 });
      return;
    }
    setLoading(true);
    try {
      const r = await authApi.signup({ ...form, ref });
      if (!r.success) {
        toast({ title: 'Não foi possível cadastrar', description: r.message, status: 'error', duration: 4000 });
        return;
      }
      // GA4: registra o cadastro como conversao (marcar como "evento principal" no painel do GA)
      try {
        (window as any).gtag?.('event', 'sign_up', { method: 'email', referral: ref || 'none' });
      } catch (e) { /* analytics nao deve quebrar o cadastro */ }
      // Entra direto no app reutilizando o login.
      const l = await login(form.email, form.password);
      if (l.success) {
        navigate("/inicio");
      } else {
        navigate('/login');
      }
    } catch (e: any) {
      toast({
        title: 'Erro ao cadastrar',
        description: e?.response?.data?.detail || 'Tente novamente',
        status: 'error',
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box bg="gray.50" minH="100vh" py={16}>
      <Container maxW="md">
        <VStack spacing={2} textAlign="center" mb={6}>
          <Heading size="lg" color="brand.600">Comece grátis</Heading>
          <Text color="gray.600">Plano grátis para sempre. Sem cartão de crédito.</Text>
        </VStack>
        <Box bg="white" borderWidth="1px" borderRadius="xl" p={6} shadow="sm">
          <VStack spacing={4}>
            <FormControl isRequired>
              <FormLabel fontSize="sm">Empresa</FormLabel>
              <Input value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} />
            </FormControl>
            <FormControl isRequired>
              <FormLabel fontSize="sm">Seu nome</FormLabel>
              <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
            </FormControl>
            <FormControl isRequired>
              <FormLabel fontSize="sm">E-mail de trabalho</FormLabel>
              <Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            </FormControl>
            <FormControl isRequired>
              <FormLabel fontSize="sm">Senha (mín. 8 caracteres)</FormLabel>
              <Input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
                onKeyDown={(e) => e.key === 'Enter' && submit()} />
            </FormControl>
            <Button colorScheme="brand" w="full" onClick={submit} isLoading={loading} loadingText="Criando conta">
              Criar conta e começar
            </Button>
            <Text fontSize="sm" color="gray.500">
              Já tem conta? <Link as={RouterLink} to="/login" color="brand.600">Entrar</Link>
            </Text>
          </VStack>
        </Box>
      </Container>
    </Box>
  );
};

export default Signup;
